
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  Ref
} from "vue";
import { useAuth } from "../../../modules/auth";
import { useToast } from "../../../modules/message";
import {
  FeaturePayload,
  FeatureClienteUpdatePayload,
  useFeatureService
} from "../../../modules/business/feature/featureBusiness";

interface FeatureSnapshot {
  idFeature: number;
  flHabilitada: boolean;
}

interface ClienteFeaturesState {
  features: Array<FeaturePayload>;
  original: Array<FeatureSnapshot>;
  stateReady: boolean;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  props: {
    idCliente: { type: Number, required: true },
    parentLoading: Boolean
  },
  setup(props) {
    const state = reactive<ClienteFeaturesState>({
      features: [],
      original: [],
      stateReady: false,
      loadings: []
    });

    const stateLoading = computed(() => {
      return state.loadings.length !== 0 || !!props.parentLoading;
    });

    const stateBlocked = computed(() => {
      return !!(
        stateLoading.value || !useAuth().amIAllowed("edit", "root-cliente")
      );
    });

    const setFeatures = (features: Array<FeaturePayload>) => {
      state.features = features.map((f) => ({
        ...f,
        flHabilitada: f.temRegistro ? f.flHabilitada : f.habilitada
      }));
      state.original = state.features.map((f) => ({
        idFeature: f.idFeature,
        flHabilitada: !!f.flHabilitada
      }));
    };

    onMounted(() => {
      const { data, loading, getFeaturesClienteRoot } = useFeatureService();
      state.loadings.push(loading);
      getFeaturesClienteRoot(props.idCliente)
        .then(() => {
          setFeatures(data.value ?? []);
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          state.stateReady = true;
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    });

    const salvarFeatures = () => {
      const alteradas: Array<FeatureClienteUpdatePayload> = state.features
        .filter((f) => {
          const original = state.original.find(
            (o) => o.idFeature === f.idFeature
          );
          return !original || original.flHabilitada !== !!f.flHabilitada;
        })
        .map((f) => ({
          idFeature: f.idFeature,
          flHabilitada: !!f.flHabilitada
        }));

      if (!alteradas.length) {
        return;
      }

      const { data, loading, updateFeaturesClienteRoot } = useFeatureService();
      state.loadings.push(loading);
      updateFeaturesClienteRoot(props.idCliente, alteradas)
        .then(() => {
          setFeatures(data.value ?? []);
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          useToast().success("Features salvas com sucesso");
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    return {
      stateLoading,
      stateBlocked,
      salvarFeatures,
      ...toRefs(state)
    };
  }
});
